module.exports = require("./fo-DK.js");